module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_30.1c54a31b.pdf";